var elements = document.getElementsByClassName("readmore");

var click_event = function() {
    var linkText = this.innerHTML.toUpperCase();
    
    if (linkText === "LIRE LA SUITE") {
        this.innerHTML = "Lire moins";
        this.previousElementSibling.classList.remove("hideContent");
        this.previousElementSibling.classList.add("showContent");

    }
    else {
        this.innerHTML = "Lire la suite";
        this.previousElementSibling.classList.remove("showContent");
        this.previousElementSibling.classList.add("hideContent");
    }
};

for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', click_event, false);
}